import styled from 'styled-components';
import {
  getInAnimationIn,
  getInAnimationOut,
} from '../../MediaLoop/Simple/animations';

export const AlertContainer = styled.div`
  animation: 1s
    ${({ show }) =>
      show ? getInAnimationIn('fade') : getInAnimationOut('fade')};
  display: flex;
  flex-direction: column;
  align-items: center;
`;
AlertContainer.displayName = 'AlertContainer';

export const Message = styled.p`
  color: #ffffff;
  font-family: 'Noto Sans', sans-serif;
  font-size: 20px;
  letter-spacing: 0px;
  line-height: 20px;
  margin: 0;
`;
Message.displayName = 'Message';

export const Title = styled.p`
  color: #ffffff;
  font-family: 'Noto Sans', sans-serif;
  font-size: 30px;
  letter-spacing: 0px;
  line-height: 30px;
  margin: 0;
  margin-bottom: 8px;
`;
Title.displayName = 'Title';
